import React from "react";
import { Box, FormHelperText, Grid2 } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { StyledLabel } from "./StyleInputs"; // You already have this
import PictureSelectItem from "./select-picture";

const PictureSelectField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>

      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <Grid2 sx={{ my: 2 }} container spacing={2}>
                {field.options?.map((option, index) => (
                  <Grid2
                    size={{ xs: 6, sm: 4, md: 3 }}
                    item
                    key={`${index}_${option.label}`}
                  >
                    <Box
                      onClick={() => onChange(option.label)}
                      sx={{
                        position: "relative",
                        border:
                          value === option.label ? "3px solid" : "3px solid",
                        borderColor:
                          value === option.label
                            ? "primary.main"
                            : "transparent",
                        borderRadius: 1.5,
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        width: "100%",
                        height: "100%",
                        backgroundColor:
                          value === option.label
                            ? "primary.50"
                            : "background.paper",
                        "&:hover": {
                          borderColor: "primary.main",
                          backgroundColor: "primary.50",
                          transform: "translateY(-2px)",
                          boxShadow: 2,
                        },
                        "&:active": {
                          transform: "translateY(0)",
                        },
                      }}
                    >
                      <PictureSelectItem
                        image={option?.image}
                        label={option?.label}
                        editable={false}
                      />
                      {value === option.label && (
                        <Box
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            backgroundColor: "secondary.main",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "0.75rem",
                            fontWeight: "bold",
                            boxShadow: 1,
                          }}
                        >
                          ✓
                        </Box>
                      )}
                    </Box>
                  </Grid2>
                ))}
              </Grid2>
              {errorMessage && (
                <FormHelperText error sx={{ mt: 1 }}>
                  {errorMessage}
                </FormHelperText>
              )}
            </>
          );
        }}
      />
    </Box>
  );
};

export default PictureSelectField;
